import React, { memo, useCallback, useEffect, useState } from 'react'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import { Helmet } from 'react-helmet/es/Helmet'
import PageTitle from '../../components/PageTitle'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Button, Dropdown, Menu, message, Modal } from 'antd'
import TinTucDetail from './TinTucDetail'
import { HeadingButtonWrapper } from '../../layouts/InternalDocumentDetailLayout/InternalDocumentDetailLayoutStyled'
import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons'
import { blue } from '../../color'
import ExclamationCircleOutlined from '@ant-design/icons/lib/icons/ExclamationCircleOutlined'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import SpinnerInlineComponent from '../../components/SpinnerInlineComponent/SpinnerInlineComponent'
import { ACL_ACTION_TYPE } from '../../constants'
import {
  ArrowLeftBroken,
  MenuDotsBoldIcon,
  Pen2OutlineIcon,
  TrashBin2OutlineIcon,
} from '../../components/AppIcon'
import { OverlayPanelWrapper } from '../../components/Overlays/OverlayPanelWrapper'
import AddEditNotificationModalV2 from '../TinTuc/AddEditNotificationModalV2'
import AppPageHeader from '../../components/AppPageHeader'

const { confirm } = Modal

const TinTucDetailPage = props => {
  const { history, loadingAnimationStore, tintucStore, match, aclStore } = props
  const { id } = match.params

  const [isLoading, setIsLoading] = useState(false)
  // Không xóa dòng khai báo aclActionsByUser (dù k dùng)
  const { aclActionsByUser } = aclStore

  const handleLoadData = useCallback(async () => {
    if (!id) return
    try {
      setIsLoading(true)
      await tintucStore.getById(id)
    } catch (error) {
      console.log(error)
      message.error(error?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  useEffect(() => {
    handleLoadData()
    return () => {
      tintucStore.clearNewDetails()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleLoadData])

  const handleClickEdit = () => {
    history.push(`/utility/general-notifications/update/${id}?isDetail=true`)
  }

  const onClickDelete = async () => {
    loadingAnimationStore.showSpinner(true)
    await tintucStore
      .delete(id)
      .then(() => {
        history.push('/utility/general-notifications')
        message.success('Đã xóa tin tức!')
      })
      .catch(err => {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
    return () => {}
  }

  function showDeleteConfirm() {
    confirm({
      title: 'Bạn có chắc muốn xóa tin này ?',
      icon: <ExclamationCircleOutlined />,
      okText: 'Đồng ý',
      okType: 'danger',
      cancelText: 'Không',
      onOk: async () => {
        await onClickDelete()
      },
      onCancel() {},
    })
  }

  const handleClickDelete = () => {
    showDeleteConfirm(id)
  }
  const menuControlNotification = (
    <Menu>
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.edit__NEWS) && (
        <OverlayPanelWrapper
          renderOverlayPanel={(open, setOpen) => (
            <AddEditNotificationModalV2
              open={open}
              setOpen={setOpen}
              selectedNotificationId={id}
              onRefresh={async () => {
                await handleLoadData()
              }}
            />
          )}>
          <Menu.Item
            style={{ color: blue, backgroundColor: 'white' }}
            icon={<Pen2OutlineIcon style={{ width: 16, height: 16 }} />}>
            Sửa thông tin
          </Menu.Item>
        </OverlayPanelWrapper>
      )}
      {aclStore.checkAccessControlAction(ACL_ACTION_TYPE.delete__NEWS) && (
        <Menu.Item
          onClick={handleClickDelete}
          danger
          icon={<TrashBin2OutlineIcon style={{ width: 16, height: 16 }} />}>
          Xóa
        </Menu.Item>
      )}
    </Menu>
  )

  return (
    <DashboardLayout>
      <Helmet>
        <title>Chi tiết tin tức</title>
      </Helmet>
      <AppPageHeader
        showBackButton
        title="Chi tiết thông báo"
        addon={
          <Dropdown overlay={menuControlNotification} trigger={['click']}>
            <Button
              style={{ width: 40, height: 40, flexShrink: 0 }}
              icon={
                <MenuDotsBoldIcon
                  style={{ width: 20, height: 20, transform: 'rotate(90deg)' }}
                />
              }
              className="custom-ant-button icon-btn"
              type="default"
            />
          </Dropdown>
        }
      />

      {isLoading ? (
        <ContentBlockWrapper style={{ height: 400, position: 'relative' }}>
          <SpinnerInlineComponent
            sizeSpin={'small'}
            isLoading={isLoading}
            noBackground
            tip={'Đang tải thông báo....'}
          />
        </ContentBlockWrapper>
      ) : (
        <TinTucDetail />
      )}
    </DashboardLayout>
  )
}

TinTucDetailPage.propTypes = {}

export default memo(
  withRouter(
    inject(
      'history',
      'tintucStore',
      'loadingAnimationStore',
      'aclStore'
    )(observer(TinTucDetailPage))
  )
)
